import classNames from 'classnames';
import { ComponentProps } from 'react';

import Box from '../Box/Box';

import verticalAlignmentAsFlexboxAlignment from './helpers/verticalAlignmentAsFlexboxAlignment';

import styles from './Column.module.css';

export type Width =
    | '1/1'
    | '1/4'
    | '1/5'
    | '1/3'
    | '1/2'
    | '3/4'
    | '2/3'
    | '2/5'
    | '3/5'
    | '1/6'
    | '1/12'
    | '11/12'
    | '5/6';

type ColumnProps = {
    width: Width;
    border?: 'left' | 'right' | 'both';
} & ComponentProps<typeof Box>;

const Column = ({
    width,
    children,
    vertical,
    border,
    className,
    ...boxProps
}: ColumnProps) => {
    const percentage = `${widthToPercentageMap[width]}%`;
    const style = {
        width: percentage,
        alignSelf: verticalAlignmentAsFlexboxAlignment(vertical),
    };

    return (
        <Box
            style={style}
            className={classNames(className, {
                [styles.borderLeft]: border === 'left' || border === 'both',
                [styles.borderRight]: border === 'right' || border === 'both',
            })}
            {...boxProps}
        >
            <div className={styles.Content}>{children}</div>
        </Box>
    );
};

export const widthToPercentageMap: Record<Width, number> = {
    '1/1': 100,
    '1/5': 20,
    '1/4': 25,
    '1/3': 33.33,
    '1/2': 50,
    '3/4': 75,
    '2/3': 66.66,
    '2/5': 40,
    '3/5': 60,
    '1/6': 16.66,
    '1/12': 8.33,
    '11/12': 91.66,
    '5/6': 83.33,
};

export default Column;
